<template>
  <modal
    :show="show"
    :show-header="false"
    header-classes="justify-content-center"
    @close="handleClose()"
  >
    <h4 class="title" v-if="participant">
      Are you sure you want to remove {{ participant.name }} from your bible study?
    </h4>

    <template slot="footer">
      <p-button @click="handleClose">
        Cancel
      </p-button>
      <p-button class="custom-modal-type" @click="handleSave">
        Yes
      </p-button>
    </template>
  </modal>
</template>

<script>
import {
    mapState, mapGetters, vuex
} from 'vuex';
import modal from '../../UIComponents/Modal';

export default {
    name: 'RemoveBSPModal',
    components: {
        modal
    },
    data() {
        return {
            namespace: 'BibleStudies',
        };
    },
    props: {
        show: Boolean,
        participant: Object,
    },
    computed: {
        ...mapState({
            error: (state) => state.BibleStudies.error,
        }),
    },
    methods: {
        handleSave() {
            const participantData = {
                id: this.participant.id,
                bible_study_id: this.participant.bible_study_id,
            };
            this.$store.dispatch(`${this.namespace}/removeBibleStudyParticipant`, {
                participant_data: participantData,
            }).then(this.handleClose());
        },
        handleClose() {
            this.$emit('close');
        },
    },
    created() {
    }
};
</script>
